export const styles = {
  xeroTitle: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  card: { padding: '2.5rem', marginBottom: '2rem' },
  input: {
    margin: '20px 0',
  },
  xeroStatusWrapper: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '18px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  mb20: {
    marginBottom: '20px',
  },
  mb30: {
    marginBottom: '20px',
  },

  mt20: {
    marginTop: '20px',
  },
}
